<script setup>
import {onMounted, computed} from "vue";
import setupAuthSubscriber from '@/stores/Subscriber';
import useHelper from "@/composables/useHelper";
import {useRoute} from "vue-router";
import {useBaseStore} from '@/stores/BaseStore';
import Headers from '@/components/navigation/Header.vue'
import {getToken} from "@/Helper";

const {setFavicon} = useHelper();
const store = useBaseStore();
const route = useRoute();
const pathsToHideHeader = ['map', 'content', 'contentDl'];
const showHeader = computed(() => !pathsToHideHeader.includes(route.name));

const loading = computed(() => store.loading);

setupAuthSubscriber();

async function initApp() {
  await store.init(getToken())
  if (store.brand) {
      setFavicon(store.brand);
  }
}

onMounted(async () => {
    await initApp(); // Wait for loadToken to complete before proceeding
});
</script>

<template>
    <div class='app'>
        <Headers v-if="showHeader"/>
        <div v-if="loading" class="loading-effect">
            <i class="fa fa-language centered-icon"></i>
            <span class="translation-text">{{ $tt('app_page__translating') }}...</span>
        </div>
        <router-view/>
    </div>
</template>

<style scoped lang='scss'>
#app {
    font-family: "Twemoji Country Flags", Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    position: relative;
}

.app {
    width: 100%;
    height: 100%;
}

.loading-effect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
            to right,
            #e0e0e0 25%,
            #c0c0c0 50%,
            #e0e0e0 75%
    );
    background-size: 200% 100%;
    animation: shimmer 1s infinite ease-in-out;
    backdrop-filter: blur(3px);
    z-index: 9999;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

.centered-icon {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2rem;
    color: #888;
}

.translation-text {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1rem;
    color: #888;
}
</style>
